// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { ReactElement } from 'react';

import { Route } from 'react-router-dom';

import { Layout } from '~/components';

import { Billing } from '../pages';

function BillingRoutes(): ReactElement {
  return (
    <Layout title="FATURAMENTO">
      <Route path="/billing" exact component={Billing.Billing} />
      <Route
        path="/billing/comercial-plan"
        exact
        component={Billing.BillingTableInformation}
      />
      <Route
        path="/billing/status"
        exact
        component={Billing.BillingTableInformation}
      />
      <Route
        path="/billing/payment-form"
        exact
        component={Billing.BillingTableInformation}
      />
      <Route
        path="/billing/finance"
        exact
        component={Billing.BillingTableInformation}
      />
    </Layout>
  );
}

export default BillingRoutes;
